import { createSlice } from '@reduxjs/toolkit';
const INITIAL_STATE = {
    loading: false,
    error: null,
    data: [],
    current: null,
    deleting: false,
    updating: false,
    currentError: null,
    creating: false,
    createError: null
};
const updateCase = (state, { payload })=>({
        ...state,
        current: payload,
        updating: true
    });
const requestComplete = (state)=>({
        ...state,
        updating: false,
        current: null
    });
export const personalTasksSlice = createSlice({
    initialState: INITIAL_STATE,
    name: 'personalTasks',
    reducers: (create)=>({
            fetchStart: create.reducer((state)=>({
                    ...state,
                    loading: true
                })),
            fetchSuccess: create.reducer((state, { payload })=>({
                    ...state,
                    data: payload,
                    loading: false
                })),
            createStart: create.reducer((state)=>({
                    ...state,
                    creating: true
                })),
            create: create.reducer((state, { payload })=>({
                    ...state,
                    data: [
                        payload,
                        ...state.data
                    ]
                })),
            createSuccess: create.reducer((state)=>({
                    ...state,
                    creating: false,
                    createError: null
                })),
            createFailure: create.reducer((state)=>({
                    ...state,
                    creating: false,
                    createError: 'error'
                })),
            deleteStart: create.reducer((state, { payload })=>({
                    ...state,
                    current: payload,
                    deleting: true
                })),
            deleteSuccess: create.reducer((state, { payload })=>({
                    ...state,
                    data: [
                        ...state.data.filter((d)=>d.personalTaskId !== payload.personalTaskId)
                    ],
                    current: null,
                    deleting: false
                })),
            deleteFailed: create.reducer((state)=>({
                    ...state,
                    current: null,
                    deleting: false
                })),
            updateStart: create.reducer(updateCase),
            update: create.reducer((state, { payload })=>({
                    ...state,
                    data: [
                        ...state.data
                    ].reduce((arr, next)=>{
                        let task = {
                            ...next
                        };
                        if (task.personalTaskId === payload.id) {
                            task = Object.assign(task, payload.data);
                        }
                        arr.push(task);
                        return arr;
                    }, []),
                    updating: false,
                    current: null
                })),
            updateSuccess: create.reducer(requestComplete),
            updateFailed: create.reducer(requestComplete)
        })
});
